export default __webpack_public_path__ + "static/media/alan.a4040fae.png";